<template>
  <div id="app" :class="$i18n.locale">
    <Navbar></Navbar>
    <div class="main">
      <router-view/>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue';
import Footer from './components/Footer.vue';
export default {
  name: 'App',
  components: {
    Navbar,
    Footer
  },
  watch: {
    // 监听路由变化
    $route: {
      handler(to, from) {
        this.updateTitle(to);
      },
      immediate: true
    }
  },
  created() {
    this.$store.dispatch('common/checkDeviceType'); // 初始化时检测设备类型
    window.addEventListener('resize', this.onResize); // 监听窗口大小变化
  },
  mounted() {
    this.$store.dispatch('loadAllModulesContent'); // 加载所有模块的内容
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize); // 组件销毁时移除事件监听
  },
  methods: {
    onResize() {
      this.$store.dispatch('common/checkDeviceType'); // 窗口尺寸变化时更新设备类型
    },
    // 路由变化时更新页面标题
    updateTitle(route) {
      if (route.name === 'home') {
        document.title = route.meta.title;  // 首页只显示首页标题
      } else {
        document.title = `${route.meta.title} - 爱福纳`;  // 非首页：当前路由标题 - 首页标题
      }
    }
  },
}
</script>

<style>
.main {
  min-height: calc(100vh - 126px);
}
@font-face {
  font-family: 'typoComicsFont'; /* 自定义字体名称 */
  src: url('./assets/fonts/typo_comics_demo.otf') format('opentype'); /* 引入字体文件 */
}
@media screen and (max-width: 768px) {
  .main {
    padding-top: 70px;
    min-height: 100vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue